import React from 'react';
import { COLORS } from '../../constants';

export default function StackBar({ good, damaged, empty, total }) {
  const getPercent = (val) => total > 0 ? (val / total) * 100 : 0;
  
  return (
    <div style={{ display: 'flex', height: 8, borderRadius: 10, overflow: 'hidden', background: COLORS.line, width: '100%' }}>
      <div style={{ width: `${getPercent(good)}%`, background: COLORS.green }} />
      <div style={{ width: `${getPercent(damaged)}%`, background: COLORS.red }} />
      <div style={{ width: `${getPercent(empty)}%`, background: COLORS.slate }} />
    </div>
  );
}